import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import MonthCalendar from "@/components/MonthCalendar";
import { MONTHS } from "@/lib/constants";

export default function EmployeeCalendar() {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);

  const { data: cal } = useQuery({
    queryKey: ["emp-cal-page", year, month],
    queryFn: async () => (await api.get(`/attendance/calendar?year=${year}&month=${month}`)).data,
  });

  const prev = () => {
    if (month === 1) { setMonth(12); setYear(year - 1); } else setMonth(month - 1);
  };
  const next = () => {
    if (month === 12) { setMonth(1); setYear(year + 1); } else setMonth(month + 1);
  };

  const c = cal?.counts || {};

  return (
    <div className="space-y-5 wp-fade-up">
      <div className="flex items-center justify-between">
        <button data-testid="cal-prev" onClick={prev} className="p-2 rounded-lg bg-white border border-slate-200"><ChevronLeft className="h-5 w-5" /></button>
        <h1 className="font-head font-extrabold text-lg">{MONTHS[month - 1]} {year}</h1>
        <button data-testid="cal-next" onClick={next} className="p-2 rounded-lg bg-white border border-slate-200"><ChevronRight className="h-5 w-5" /></button>
      </div>

      <div className="grid grid-cols-3 gap-2 text-center">
        {[["Present", c.present], ["Half Day", c.half_day], ["Absent", c.absent]].map(([l, v]) => (
          <div key={l} className="bg-white rounded-xl p-3 border border-slate-200">
            <div className="text-xl font-head font-extrabold">{v ?? 0}</div>
            <div className="text-[11px] text-slate-500">{l}</div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-2xl p-4 border border-slate-200">
        <MonthCalendar year={year} month={month} days={cal?.days} />
      </div>
    </div>
  );
}
